/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Notify that a setting was updated (broadcasts to other sessions)
 */
export interface SettingsClientMessageOneOf1 {
    category: string;
    key: string;
    type: SettingsClientMessageOneOf1TypeEnum;
    value: any | null;
}
export enum SettingsClientMessageOneOf1TypeEnum {
    SettingsUpdated = 'settings_updated'
};
